import { cropMediaFragment } from './cropMediaFragment';

export const fullContentFragment = `Contents(
      where: $where
      locale: $locale
      limit: $limit
      page: $page
      draft: $draft
      sort:$sort
    ) {
      docs {
        id
        body
        title
        description
        slug
        type
        seo
        subType
        isFeatured
        newsSources 
        publishedAt
        createdAt
        updatedAt
        audioNarration
        duration
        primaryTopics {
          id
          page {
            slug
            name
          }
        }
        tvShow {
          id
          title
          description
          coverImage {
        ${cropMediaFragment}
        }
        }

        author {
          id_
          name
          profileUrl
          profilePicture {
            url
            type
            caption
            thumbnailUrl
          }
        }
        otherAuthors {
          id_
          name
          profileUrl
          profilePicture {
            url
            type
            caption
            thumbnailUrl
          }
        }
       
        coverImage 
        media 
        coverMedia         
        readingTime {
          text
          minutes
        }
        websiteBlockDetails 
        showByLine
        showAuthorBio
      }
      hasNextPage
      hasPrevPage
      limit
      offset
      page
      pagingCounter
      totalDocs
      totalPages
    }`;
